import React, { Component } from 'react'

import FlashAlert from 'components/molecules/alert'
import ClientProfileEditForm from 'components/organisms/client_profile_edit_form'

class ProfileEdit extends Component{
    render(){
        return(
            <>
                <FlashAlert/>
                <section className='p-4'>
                    <h4 className='text-secondary'>Mi perfil</h4>
                    <ClientProfileEditForm/>
                </section>
            </>
        )
    }
}

export default ProfileEdit